import { apiRequest } from '../../../../shared/api/index.js';

/**
 * A 204 carries no body, so there is nothing to run a schema over. The server answers 409 when a
 * payment still points at the card; the caller turns that into the offer to archive it instead.
 */
export const deleteCard = async (id: string): Promise<void> => {
  await apiRequest<void>(`/cards/${id}`, { method: 'DELETE' });
};
